var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479-110 179-273v-240L18-600l461-251 463 251v328h-83v-280l-79 39v240L479-110Zm0-333 287-157-287-154-285 154 285 157Zm0 239 217-120v-140L479-349 262-466v142l217 120Zm1-239Zm-1 84Zm0 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradwhite);
export default __webpack_public_path__ + "static/media/gradwhite.a92525c2f6ba79c56be15e11b8ea7eb0.svg";
export { ForwardRef as ReactComponent };